"use client";

import Image from "next/image";
import styles from "@/styles/global/infinite-list-loading.module.scss";

interface InfiniteListLoadingProps {
  size?: number;
  src?: string;
}

export default function InfiniteListLoading({
  size = 36,
  src = `${process.env.IMAGE_DOMAIN}/svg/loading.svg`,
}: InfiniteListLoadingProps) {
  return (
    <Image
      className={styles["loading-icon"]}
      src={src}
      alt="Loading"
      width={size}
      height={size}
    />
  );
}
